import React from 'react';
import { Chip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@mui/material/Tooltip';
import { GridColDef } from '@mui/x-data-grid';
import { diamGridStringFilterOperators } from '../../diamGridUtils';
import {
  GridActionButton,
  RoleContainer,
  RoleDescription,
  RoleName,
  StyledDeleteIcon,
} from '../DiamDataGrid/styles';
import { TeamRole, TeamRoleActionHandlers } from './types';

export function buildTeamRoleColumns({
  onEdit,
  onDelete,
  formatDateTime,
}: TeamRoleActionHandlers & {
  formatDateTime: (dateIso?: string | null) => string;
}): GridColDef<TeamRole>[] {
  return [
    {
      field: 'name',
      headerName: 'Role',
      flex: 1.5,
      minWidth: 240,
      filterOperators: diamGridStringFilterOperators,
      valueGetter: (_value, row) => `${row.name}, ${row.description}`,
      renderCell: ({ row }) => (
        <RoleContainer>
          <RoleName>{row.name}</RoleName>
          <RoleDescription title={row.description}>
            {row.description}
          </RoleDescription>
        </RoleContainer>
      ),
    },
    {
      field: 'scope',
      headerName: 'Scope',
      flex: 0.9,
      minWidth: 160,
      filterable: false,
      sortable: false,
      renderCell: ({ row }) => <Chip color="primary" label={row.scope} />,
    },
    {
      field: 'createdAt',
      headerName: 'Created at',
      flex: 0.9,
      minWidth: 170,
      filterable: false,
      getApplyQuickFilterFn: () => null,
      renderCell: ({ row }) => formatDateTime(row.createdAt),
    },
    {
      field: 'updatedAt',
      headerName: 'Updated at',
      flex: 0.9,
      minWidth: 170,
      filterable: false,
      getApplyQuickFilterFn: () => null,
      renderCell: ({ row }) => formatDateTime(row.updatedAt),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      align: 'center',
      cellClassName: 'actions-cell',
      filterable: false,
      getApplyQuickFilterFn: () => null,
      headerAlign: 'center',
      minWidth: 100,
      sortable: false,
      renderCell: ({ row }) => (
        <>
          <Tooltip title="Edit">
            <GridActionButton
              aria-label={`Edit ${row.name}`}
              color="primary"
              onClick={event => {
                event.stopPropagation();
                onEdit?.(row);
              }}
            >
              <EditIcon fontSize="small" color="primary" />
            </GridActionButton>
          </Tooltip>
          <Tooltip title="Delete">
            <GridActionButton
              aria-label={`Delete ${row.name}`}
              onClick={event => {
                event.stopPropagation();
                onDelete?.(row);
              }}
            >
              <StyledDeleteIcon />
            </GridActionButton>
          </Tooltip>
        </>
      ),
    },
  ];
}
